import { Controller } from "@hotwired/stimulus"

export default class NavigationController extends Controller {
  static values = {
    url: String,
    frame: String,
    turbo: { type: Boolean, default: true }
  }

  open(event) {
    event.preventDefault()

    if (!this.turboValue) {
      globalThis.location.href = this.urlValue
      return
    }

    if (this.hasFrameValue) {
      Turbo.visit(this.urlValue, {
        frame: this.frameValue
      })
    } else {
      Turbo.visit(this.urlValue)
    }
  }
}